import { render } from "./LoginError.vue?vue&type=template&id=659c9dff"
import script from "./LoginError.vue?vue&type=script&lang=js"
export * from "./LoginError.vue?vue&type=script&lang=js"
script.render = render

export default script